export function stickyVariables() {
    const stickyGroups = Array.from(document.querySelectorAll('[data-stickyGroup]'));
    const stickyGroupsFromTopArray = stickyGroups.map(group => group.offsetTop);
    const stickySections = Array.from(document.querySelectorAll('[data-stickySection]'));
    const stickySectionsFromTopArray = stickySections.map(section => section.offsetTop);
    //const stickyButtons = document.querySelectorAll('[data-stickyNav]');
    
    const pageScrollPosition = Math.floor(window.scrollY);
    
    return { stickyGroups, stickyGroupsFromTopArray, stickySections, stickySectionsFromTopArray, pageScrollPosition };
}